// @flow
import React, {Component} from 'react';
import {View, StyleSheet, Image} from 'react-native';
import {Button, EmphasizedSubText} from 'trpc-react-native-ui';

import theme from '../../../../theme-config';

type Props = {
  disabled: boolean,
  isActive: boolean,
  label: string,
  topRightImageName: string,
  description: string,
  onSelect: Function,
  style: Object,
};

class SIMRadioButton extends Component<Props> {
  styles = getStyles();

  buttonContainerViewStyle = () => {
    if (this.props.isActive) {
      return this.styles.activeButtonContainer;
    } else {
      return this.styles.buttonContainer;
    }
  };

  viewStyle = () => {
    if (this.props.isActive) {
      return this.styles.selectedRadioButtonOuterRing;
    } else {
      return this.props.disabled
        ? this.styles.disabledRadioButtonOuterRing
        : this.styles.inactiveRadioButtonOuterRing;
    }
  };

  textStyle = () => {
    if (!this.props.isActive) {
      return this.props.disabled
        ? this.styles.disabledLabel
        : this.styles.inactiveLabel;
    }
  };

  render() {
    const {disabled, isActive, label, onSelect, style} = this.props;

    return (
      <Button
        style={[this.styles.buttonContainer, this.buttonContainerViewStyle()]}
        onPress={onSelect}
        disabled={disabled}>
        <View style={this.styles.buttonTopContainer}>
          <View style={this.styles.radioButtonTextContainer}>
            <View style={[this.styles.radioButtonOuterRing, this.viewStyle()]}>
              {isActive && <View style={this.styles.selectedRadioButton} />}
            </View>
            <EmphasizedSubText
              style={[this.styles.label, this.textStyle()]}
              emphStyle={this.styles.adviseEmphasis}
              text={label}
            />
          </View>
          <View style={this.styles.iconContainer}>
            <Image
              style={this.styles.imageStyle}
              source={this.props.topRightImageName}
              resizeMode="contain"
            />
          </View>
        </View>
        <View style={this.styles.buttonBottomContainer}>
          <View style={this.styles.line}></View>
          <View style={this.styles.descriptionItemContainer}>
            <View style={this.styles.descriptionItemLeftContainer}>
              <EmphasizedSubText
                style={[this.styles.bulletPoint, this.textStyle()]}
                emphStyle={this.styles.adviseEmphasis}
                text="• "
              />
            </View>
            <View style={this.styles.descriptionItemRightContainer}>
              <EmphasizedSubText
                style={[this.styles.labelDetails, this.textStyle()]}
                emphStyle={this.styles.adviseEmphasis}
                text={this.props.description}
              />
            </View>
          </View>
        </View>
      </Button>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    buttonContainer: {
      borderWidth: 0.5,
      borderRadius: 20,
      borderColor: theme.secondaryColor,
    },
    activeButtonContainer: {
      borderWidth: 4,
      borderRadius: 20,
      borderColor: theme.secondaryColor,
    },
    buttonTopContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 10,
      marginLeft: 15,
      marginRight: 15,
      marginBottom: 6,
    },
    radioButtonTextContainer: {
      flex: 7,
      flexDirection: 'row',
      alignItems: 'center',
    },
    iconContainer: {
      flex: 1,
    },
    buttonBottomContainer: {
      marginBottom: 10,
    },
    descriptionItemContainer: {flexDirection: 'row'},
    descriptionItemLeftContainer: {flex: 1},
    descriptionItemRightContainer: {flex: 10},
    label: {
      color: theme.signUpInputTextColor,
      fontSize: 15,
      fontWeight: 'bold',
      marginLeft: 15,
    },
    labelDetails: {
      color: theme.signUpInputTextColor,
      fontSize: 15,
      marginVertical: 10,
    },
    bulletPoint: {
      color: theme.signUpInputTextColor,
      fontSize: 21,
      marginLeft: 15,
      marginVertical: 10,
    },
    radioButtonOuterRing: {
      width: 25,
      height: 25,
      borderWidth: 2,
      borderRadius: 50,
      borderColor: theme.signUpInputTextColor,
      alignItems: 'center',
      justifyContent: 'center',
    },
    selectedRadioButtonOuterRing: {
      borderWidth: 2,
    },
    selectedRadioButton: {
      width: 16,
      height: 16,
      borderRadius: 40,
      backgroundColor: theme.signUpInputTextColor,
    },
    inactiveLabel: {
      color: theme.signUpInputTextColor,
    },
    inactiveRadioButtonOuterRing: {
      borderColor: theme.signUpInputTextColor,
    },
    disabledLabel: {
      color: theme.simRadioButton.disabled,
    },
    disabledRadioButtonOuterRing: {
      borderColor: theme.simRadioButton.disabled,
    },
    adviseEmphasis: {
      fontWeight: 'bold',
      textAlign: 'center',
    },
    imageStyle: {
      width: 45,
      height: 45,
    },
    itemIcon: {
      alignSelf: 'center',
    },
    line: {
      height: 1,
      width: '100%',
      backgroundColor: theme.signUpInputTextColor,
    },
  });

export default SIMRadioButton;
